'use client';

import Image from 'next/image';

interface TeamMember {
  name: string;
  role: string;
  image: string;
  alt: string;
  initials: string;
  linkedin: string;
}

const teamMembers: TeamMember[] = [
{
  name: 'Jayadeep Unni',
  role: 'Founder & CEO',
  image: '/assets/images/jaypic-1766936251923.png',
  alt: 'Jayadeep Unni, Founder & CEO of Sensivision Health Technologies Pvt. Ltd. in business attire',
  initials: 'JU',
  linkedin: 'https://www.linkedin.com/in/jayadeep-unni-a929ba'
},
{
  name: 'Rohini Krishnamurthy',
  role: 'Director, Product & Manufacturing',
  image: '/assets/images/RK-1766936496847.png',
  alt: 'Rohini Krishnamurthy, Director of Product & Manufacturing in professional red top with outdoor background',
  initials: 'RK',
  linkedin: 'https://www.linkedin.com/in/rohinikrishnamoorthy/'
},
{
  name: 'Ashim Purohit',
  role: 'Chief Motivation Officer',
  image: '/assets/images/AP-1766936710499.png',
  alt: 'Ashim Purohit, Chief Business Officer in glasses and blue shirt',
  initials: 'AP',
  linkedin: 'https://www.linkedin.com/in/ashim-purohit-aa68749/'
},
{
  name: 'Amala Nair',
  role: 'Product Manager',
  image: '/assets/images/Screenshot_2025-12-28_at_9.23.04_PM-1766937195772.png',
  alt: 'Amala Nair, Product Manager in beige blazer and dark green top with professional smile',
  initials: 'AN',
  linkedin: 'https://www.linkedin.com/in/amala-nair-c-81425a19/'
},
{
  name: 'Cherian K.M',
  role: 'Sales South',
  image: '/assets/images/KMC-1766936789507.png',
  alt: 'Cherian K.M, Sales South region in light colored polo shirt with cap',
  initials: 'CK',
  linkedin: 'https://www.linkedin.com/in/cherian-km/'
},
{
  name: 'Devang Lakhia',
  role: 'Sales West & North',
  image: '/assets/images/DL-1766939312426.png',
  alt: 'Devang Lakhia, Sales West & North regions wearing suit and tie',
  initials: 'DL',
  linkedin: 'https://www.linkedin.com/in/devanglakhia/'
},
{
  name: 'Shjill Varghese',
  role: 'Design Engineer',
  image: '/assets/images/WhatsApp_Image_2025-12-28_at_17.24.23-1766937333183.jpeg',
  alt: 'Shjill Varghese, Design Engineer in formal black pinstripe suit with white shirt and dark patterned tie',
  initials: 'SV',
  linkedin: 'https://www.linkedin.com/in/shijil-varghese-b529061b5/'
},
{
  name: 'Abhinav Shayish',
  role: 'Design Engineer',
  image: '/assets/images/WhatsApp_Image_2025-12-28_at_17.29.21-1766937456512.jpeg',
  alt: 'Abhinav Shayish, Design Engineer in dark business suit with white shirt and red patterned tie',
  initials: 'AS',
  linkedin: 'https://www.linkedin.com/in/abhinav-shayish/'
},
{
  name: 'Shiva Sharma',
  role: 'Business Development Executive, North',
  image: '/assets/images/Screenshot_2025-12-28_at_9.20.51_PM-1766937090748.png',
  alt: 'Shiva Sharma, Sales North region in dark business suit with white shirt and red patterned tie',
  initials: 'SS',
  linkedin: 'https://www.linkedin.com/in/shiva-sharma-8292761b9/'
},
{
  name: 'Kavebharthi',
  role: 'Verification Engineer',
  image: '/assets/images/WhatsApp_Image_2025-12-29_at_15.53.10-1767267728803.jpeg',
  alt: 'Kavebharthi, Verification Engineer in professional attire',
  initials: 'KB',
  linkedin: 'https://www.linkedin.com/in/kavebharthi-s-575a552a9/'
}];

// Members with actual images (not fallback initials)
const membersWithImages = [
  'Jayadeep Unni',
  'Rohini Krishnamurthy',
  'Amala Nair',
  'Ashim Purohit',
  'Cherian K.M',
  'Shjill Varghese',
  'Shiva Sharma',
  'Abhinav Shayish',
  'Devang Lakhia',
  'Kavebharthi'
];

const TeamSection = () => {
  return (
    <section id="team" className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-bold text-gray-900 mb-4 text-[32px]">
            Meet Our Team
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">The dedicated team behind REVIVE, committed to transforming neonatal care in India and beyond

          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) =>
          <a
            key={index}
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white rounded-3xl p-6 shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer">

              {/* Profile Image with Fallback */}
              <div className="relative w-40 h-40 mx-auto mb-4 overflow-hidden rounded-full ring-4 ring-primary/10 group-hover:ring-primary/30 transition-all duration-300">
                {membersWithImages.includes(member.name) ? (
              <Image
                src={member.image}
                alt={member.alt}
                fill
                className={`object-cover ${
                member.name === 'Amala Nair' ? 'object-center' :
                member.name === 'Shjill Varghese' ? 'object-center' : ''}`
                }
                sizes="160px" />
                ) : (
              <div className="w-full h-full bg-gradient-to-br from-primary to-blue-600 flex items-center justify-center">
                    <span className="text-white text-4xl font-bold">
                      {member.initials}
                    </span>
                  </div>
                )}
              </div>

              {/* Member Info */}
              <div className="text-center">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {member.name}
                </h3>
                <p className="text-primary font-medium mb-3">{member.role}</p>
                <div className="flex items-center justify-center gap-2 text-sm text-blue-600 group-hover:text-blue-700">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                  <span className="font-medium">LinkedIn</span>
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>);

};

export default TeamSection;